module.exports = __webpack_public_path__ + "static/muffin-c7cb998c3908c150edfb9e29d9702bdd.svg";